"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalGeneratorContainer = exports.toGeneratorOptions = exports.defaultPricingOptions = void 0;
const React = __importStar(require("react"));
const helpers_1 = require("../../../../entities/pricing/helpers");
const diem_1 = __importDefault(require("@travelnest/diem"));
const PricingGeneratorModal_1 = require("../../../components/pricing-generator-modal/PricingGeneratorModal");
const seasonality_1 = require("../../../../entities/pricing/seasonality");
const pricing_generator_1 = __importStar(require("../../../../entities/pricing/pricing-generator"));
const useMarketInsight_1 = require("../../../../hooks/useMarketInsight");
const useFxRates_1 = require("../../../../hooks/useFxRates");
const helpers_2 = require("./helpers");
const fullStory_1 = require("../../../../util/fullStory");
const defaultPricingOptions = (startDate, price) => ({
    standardPricePerNight: price,
    minimumStay: 1,
    arrivalDays: (0, helpers_1.allDaysAllowed)(),
    startDate,
    seasonalityTemplate: seasonality_1.SeasonalityTemplate.Gradual
});
exports.defaultPricingOptions = defaultPricingOptions;
const toGeneratorOptions = (modalOptions, currency) => {
    return {
        arrival_days: modalOptions.arrivalDays,
        departure_days: (0, helpers_1.allDaysAllowed)(),
        currency,
        min_stay: modalOptions.minimumStay,
        seasonality: modalOptions.seasonalityTemplate,
        min_price: Math.round(modalOptions.standardPricePerNight * pricing_generator_1.minPriceFactor),
        standard_price: modalOptions.standardPricePerNight,
        max_price: Math.round(modalOptions.standardPricePerNight * pricing_generator_1.maxPriceFactor)
    };
};
exports.toGeneratorOptions = toGeneratorOptions;
const ModalGeneratorContainer = (props) => {
    const { propertyId, isOpen, insightPrice, hasExistingPricing, currentPricingEnd, currency, defaultPrice, onCloseTap, onPricingGenerated } = props;
    const startDate = new diem_1.default();
    const { loadingInsight, insight } = (0, useMarketInsight_1.useMarketInsight)(props.propertyId);
    const { loadingFxRates, fxRates } = (0, useFxRates_1.useFxRates)();
    const [pricingSuggestion, setPricingSuggestion] = React.useState(null);
    const [modalOptions, setModalOptions] = React.useState((0, exports.defaultPricingOptions)(startDate, insightPrice));
    React.useEffect(() => {
        // Update the modal options when the inputs change
        setModalOptions((0, exports.defaultPricingOptions)(startDate, insightPrice));
    }, [currentPricingEnd, insightPrice]);
    // Attempt to generate a pricing suggestion
    React.useEffect(() => {
        if (!loadingInsight && !loadingFxRates) {
            const lowInsight = insight === null || insight === void 0 ? void 0 : insight.rate_percentiles[25];
            const highInsight = insight === null || insight === void 0 ? void 0 : insight.rate_percentiles[75];
            if (lowInsight && highInsight) {
                const low = (0, helpers_2.convertToCurrency)(lowInsight, currency, fxRates);
                const high = (0, helpers_2.convertToCurrency)(highInsight, currency, fxRates);
                if (low !== undefined && high !== undefined) {
                    setPricingSuggestion({ low, high });
                }
            }
        }
    }, [loadingInsight, loadingFxRates]);
    if (isOpen) {
        return React.createElement(PricingGeneratorModal_1.PricingGeneratorModal, { currency: currency, defaultPrice: defaultPrice, hasExistingPricing: hasExistingPricing, onClose: () => onCloseTap(), pricingOptions: modalOptions, onChangeOption: (field, value) => setModalOptions(Object.assign(Object.assign({}, modalOptions), { [field]: value })), generatePricing: () => {
                onPricingGenerated((0, pricing_generator_1.default)(propertyId, (0, exports.toGeneratorOptions)(modalOptions, currency), modalOptions.startDate).map((p) => p.pricingPeriod));
                (0, fullStory_1.sendCustomFullStoryEvent)('pricing_recommendation', Object.assign(Object.assign(Object.assign({ seasonality: modalOptions.seasonalityTemplate, currency, standard_price: modalOptions.standardPricePerNight }, ((pricingSuggestion === null || pricingSuggestion === void 0 ? void 0 : pricingSuggestion.low) ? { insight_lower: pricingSuggestion.low } : {})), ((pricingSuggestion === null || pricingSuggestion === void 0 ? void 0 : pricingSuggestion.high) ? { insight_upper: pricingSuggestion.high } : {})), (insight ? {
                    percentiles: {
                        p05: insight.rate_percentiles['5'],
                        p25: insight.rate_percentiles['25'],
                        p50: insight.rate_percentiles['50'],
                        p75: insight.rate_percentiles['75'],
                        p95: insight.rate_percentiles['95'],
                    }
                } : {})));
            }, pricingSuggestion: pricingSuggestion });
    }
    else {
        return null;
    }
};
exports.ModalGeneratorContainer = ModalGeneratorContainer;
//# sourceMappingURL=Generator.js.map